import Vue from 'vue';

import {
  library
} from '@fortawesome/fontawesome-svg-core';

import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';

import {
  faPlus,
  faTrash,
  faPencil,
  faFolderOpen
} from '@fortawesome/pro-regular-svg-icons'

library.add(faPlus, faTrash, faPencil, faFolderOpen);

Vue.component('font-awesome-icon', FontAwesomeIcon);